<section class="error-page">
  <h1 class="error-page__code">401</h1>
  <p class="error-page__message">You are not signed in.</p>
</section>
